"use client";

import { useTranslations } from "@i18n/react";
import { useEffect } from "react";

import { useAlert } from "../components/_base/modals/Dialog/Dialog";

type ErrorNotificationProps = {
  isError: boolean;
  title?: string;
  description?: string;
};

export function useErrorNotification({
  isError,
  title,
  description,
}: ErrorNotificationProps) {
  const alert = useAlert({ button: "Ok" });
  const t = useTranslations();

  useEffect(() => {
    if (isError && !alert.visible) {
      alert.show({
        id: "error-notification",
        title: title ?? t("general_word_error"),
        description,
      });
    }
  }, [isError]);
}
